<template>
  <div class="zl-form">
    <el-form v-if="loaded" ref="form" class="zl-form-form" :model="data" label-width="auto" @submit.native.prevent>
      <!-- 源表单 -->
      <div
        v-for="(item, index) in form"
        :key="index"
        class="zl-form-group"
        :class="{'no-group': !item.group.length }"
      >
        <div v-if="item.title" class="zl-form-group-header">
          <div class="zl-form-group-title">
            <i class="title-decorate iconfont icon-decorate" />
            <!-- {{ $t(item.title) }} -->
            <component :is="getTitleComponents(item.title)" :data="data || {}" class="detail-page-title">{{ $te(item.title) ? $t(item.title) : item.title }}</component>
          </div>
          <component
            :is="item.subTitle"
            v-if="item.subTitle"
            :data="data"
            :item="item"
          />
        </div>
        <div class="zl-form-group-form">
          <form-list :data="data" :row="item.row || { gutter: 20 }" :options="item.group" />
        </div>
      </div>
      <!-- 自定义字段 -->
      <div
        v-for="(item, index) in (hasCustomForm ? customForm: [])"
        :key="'custom' + index"
        class="zl-form-group"
      >
        <div v-if="item.title" class="zl-form-group-header">
          <div class="zl-form-group-title">
            <i class="title-decorate iconfont icon-decorate" />
            {{ $t(item.title) }}
          </div>
        </div>
        <div class="zl-form-group-form">
          <form-list :data="data" :row="item.row || { gutter: 20 }" :options="item.group" />
        </div>
      </div>
    </el-form>
    <!-- 按钮 -->
    <div class="zl-form-buttons">
      <el-button
        v-for="(item, index) in btns"
        :key="index"
        class="zl-form-submit"
        :type="item.type"
        @click="tapBtn(item)"
      >
        {{ $t(item.text) }}
      </el-button>
      <!-- <el-button class="zl-form-submit" type="primary" :disabled="!loaded" @click="submit">{{ $t('common.submit') }}</el-button>
      <el-button v-if="type === 'add'" type="success" :disabled="!loaded" @click="submitAndAdd">{{ $t('common.submitAndAdd') }}</el-button>
      <el-button @click="$router.back()">{{ $t('common.cancel') }}</el-button> -->
    </div>
  </div>
</template>

<script>
import FormList from '../components/add-page-list.js'
import emitter from 'element-ui/src/mixins/emitter'
import { getSysFrameDefineListByModule } from '@/api/common/index'
import { initForm, getData, getCustomForm, getCustomTableFormItem } from './custom'

const defaultBtns = [
  { type: 'primary', event: 'submit', text: 'common.submit' },
  { type: 'success', event: 'submitAndAdd', text: 'common.submitAndAdd', show() { return this.type === 'add' } },
  { type: 'default', text: 'common.cancel', handle() { this.$router.back() } }
]

function copyFormItem(item, map) {
  if (Array.isArray(item)) {
    return item.map(i => copyFormItem(i, map))
  } else {
    const copy = { ...item }
    const key = copy.mapKey || copy.prop
    map.set(key, copy)
    return copy
  }
}

function getFormItem(form) {
  if (Array.isArray(form)) {
    return form.map(item => {
      if (Array.isArray(item)) {
        return getFormItem.call(this, item)
      } else {
        const show = typeof item.show === 'function' ? item.show(this) : item.show
        return show === false ? null : item
      }
    }).filter(i => i && !(Array.isArray(i) && !i.length))
  }
  const show = typeof form.show === 'function' ? form.show(this) : form.show
  return show === false ? null : form
}

function getCopyForm(form, map) {
  return form.map(item => {
    return {
      ...item,
      group: copyFormItem(item.group, map)
    }
  })
}

export default {
  name: 'ZlFormPage',
  componentName: 'ZlFormPage',
  components: {
    FormList
  },
  provide() {
    return {
      $page: this
    }
  },
  mixins: [emitter],
  props: {
    // eslint-disable-next-line
    $form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loaded: false,
      data: {},
      copyForm: [],
      formMap: new Map(),
      // 是否有自定义数据[如果没有直接标题也不会渲染]
      hasCustomForm: false,
      // 自定义表单的配置
      customForm: [],
      // 自定义表单身的配置[当前页不会使用，提供到表单子身的组件中使用]
      customTableFormItem: []
    }
  },
  computed: {
    form() {
      return this.copyForm.map(item => {
        return {
          ...item,
          group: getFormItem.call(this, item.group)
        }
      })
    },
    type() {
      return this.$form._type
    },
    btns() {
      const btn = this.$form._btns || defaultBtns
      return btn.filter(item => (!item.show || item.show.call(this)))
    },
    prefix() {
      return this.$form.prefix
    }
  },
  async created() {
    // 初始化form配置数据
    this.copyForm = Object.freeze(getCopyForm(this.$form.form, this.formMap))
    this.$on('page.setitem', this.setitem)
    // 获取数据
    this.loaded = this.$form._autoCreateForm
    this.$form.created && this.$form.created(this)
    // 接口获取自定义表单项的数据
    const customField = await getSysFrameDefineListByModule(this.$route.meta.dep)
    // 格式化后端数据
    this.customForm = Object.freeze(getCustomForm(customField))
    // 判断是否有自定义表单项（没有直接连title也不渲染）
    this.hasCustomForm = !!this.customForm[0].group.length
    // ||||||| 格式化表单身数据 |||||||
    this.customTableFormItem = Object.freeze(getCustomTableFormItem(customField))
    // 初始化表单数据
    const { formItemMap } = initForm.call(this, this.customForm)
    const customData = getData({ ...formItemMap })
    this.data = this.$form.getData ? { ...this.$form.getData(), ...customData } : { ...customData }
    if (this.$form && this.$form.getFn) {
      await this.$form.getFn.call(this)
    }
    this.$form.formLoaded && this.$form.formLoaded(this)
  },
  mounted() {
    this.$form.mounted && this.$form.mounted(this)
  },
  destroyed() {
    this.$form.destroyed && this.$form.destroyed(this)
  },
  methods: {
    getTitleComponents(title) {
      if (title && typeof title === 'object') {
        return title
      }
      return 'div'
    },
    setitem(prop, value = {}) {
      const item = this.formMap.get(prop)
      if (!item) return
      if (typeof value === 'function') {
        value = value(item)
      }
      Object.assign(item, value)
      this.$nextTick(() => {
        this.formMap = new Map()
        this.copyForm = Object.freeze(getCopyForm(this.copyForm, this.formMap))
      })
    },
    createForm() {
      this.loaded = true
    },
    setData(data) {
      if (data && typeof data === 'object') {
        Object.keys(data).forEach(key => {
          if (key in this.data) {
            this.data[key] = data[key]
          }
        })
      }
    },
    tapBtn(item) {
      if (item.event) {
        this[item.event]()
      } else if (item.handle) {
        item.handle.call(this, item)
      }
    },
    submit() {
      const submit = this.$form.submitFn || this.$form.submit
      this.$refs.form.validate(async valid => {
        if (!valid) return
        await submit.call(this, this.data)
        this.$router.back()
      })
    },
    submitAndAdd() {
      const submit = this.$form.submitFn || this.$form.submit
      this.$refs.form.validate(async valid => {
        if (!valid) return
        await submit.call(this, this.data)
        this.$message({ message: this.$t('message.success'), type: 'success' })
        this.dispatch('Layout', 'layout.refresh', [this])
      })
    },
    // 重置页面
    reset() {
      this.dispatch('Layout', 'layout.refresh', [this])
    }
  }
}
</script>

<style lang="scss" scoped>
.zl-form {
  &-group {
    background: #ffffff;
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 18px;
    margin-bottom: 12px;
    &.no-group{
      padding-top: 0;
    }
  }
  &-group-header {
    color: #757575;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 18px;
  }
  &-group-title {
    position: relative;
    margin: 0 -10px;
    display: inline-flex;
    align-items: center;
    .title-decorate {
      transform: scale(.7);
      color: #008EE3;
      margin-right: 2px;
    }
    .title-warning {
      background: #FFEDE1;
      color: #FF9E00;
      border-radius:2px;
      font-size:12px;
      padding: 3px 8px;
      margin-left: 5px;
    }
  }
  &-group-form {
    padding: 0 12px;
  }
  &-submit {
    padding-left: 35px;
    padding-right: 35px;
  }
  /deep/ {
    .el-input-number {
      width: 100%;
      .el-input__inner {
        text-align: left;
      }
    }
  }
}
</style>
